// Fronted/src/components/admin/homescreens/EventsSection.jsx
import { FaCalendar } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { useEvents } from "../../contexts/EventsContext";

const EventsSection = () => {
  const navigate = useNavigate();
  const { events } = useEvents();

  if (!events) {
    return <div>Loading Events...</div>;
  }

  const formatEventDate = (dateString) => {
    if (!dateString) return "Date not specified";
    
    try {
      const date = new Date(dateString);
      // Check if the date is valid
      if (isNaN(date.getTime())) {
        return "Invalid date";
      }
      return Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(date);
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Invalid date";
    }
  };

  return (
    <div className="w-full bg-white rounded-lg shadow-lg p-4 mt-4">
      <h2 className="text-xl font-bold text-black mb-1">Events</h2>
      <p className="text-sm text-primary font-bold mb-4">Don't miss our upcoming events</p>
      <ul className="w-full">
        {events.length > 0 ? (
          events.map((event, index) => (
            <li 
              key={event.id} 
              className={`w-full py-3 ${index < events.length - 1 ? "" : ""}`}
              onClick={() => navigate(`/events/?category=events`)}
            >
              <div className="flex flex-col">
                <p className="font-medium text-dark">{event.title}</p>
                <div className="flex items-center font-bold text-sm text-primary mt-1">
                  <FaCalendar className="mr-2" />
                  <span>{formatEventDate(event.date)}</span>
                  {event.location && (
                    <span className="ml-2 text-xs bg-gray-100 px-2 py-1 rounded-full">
                      {event.location}
                    </span>
                  )}
                </div>
              </div>
            </li>
          ))
        ) : (
          <li className="w-full py-3 text-center text-gray-500">
            No upcoming events
          </li>
        )}
      </ul>
    </div>
  );
};

export default EventsSection;